import { useCallback } from 'react';
import { useContentUsageLimitsProvider } from '../providers/ContentUsageLimitsProvider';
const defaultContentUsageLimit = {
  limit: null,
  quantityUsed: 0
};
const useContentUsageLimits = () => {
  const {
    contentUsageLimits
  } = useContentUsageLimitsProvider();
  const getContentUsageLimit = useCallback(limitName => {
    if (limitName in contentUsageLimits) {
      return contentUsageLimits[limitName];
    }
    return defaultContentUsageLimit;
  }, [contentUsageLimits]);
  const getLimitValue = useCallback(limitName => getContentUsageLimit(limitName).limit, [getContentUsageLimit]);
  const getQuantityUsedValue = useCallback(limitName => getContentUsageLimit(limitName).quantityUsed, [getContentUsageLimit]);
  const getHasExceededUsageLimit = useCallback(limitName => {
    const {
      limit,
      quantityUsed
    } = getContentUsageLimit(limitName);
    return limit ? quantityUsed > limit : false;
  }, [getContentUsageLimit]);
  const getHasReachedUsageLimit = useCallback(limitName => {
    const {
      limit,
      quantityUsed
    } = getContentUsageLimit(limitName);
    return limit ? quantityUsed >= limit : false;
  }, [getContentUsageLimit]);
  const getAmountOverLimit = useCallback(limitName => {
    const {
      limit,
      quantityUsed
    } = getContentUsageLimit(limitName);
    return limit && quantityUsed > limit ? quantityUsed - limit : 0;
  }, [getContentUsageLimit]);
  return {
    getAmountOverLimit,
    getHasExceededUsageLimit,
    getHasReachedUsageLimit,
    getQuantityUsedValue,
    getLimitValue,
    contentUsageLimits
  };
};
export default useContentUsageLimits;